module.exports = __webpack_public_path__ + "img/MARCA_COM_BORDA.d20bd058.png";